export class UserSecurityDto {
  key: number;
  label: string = '';
  canRead: boolean = false;
  canEdit: boolean = false;
  canDelete: boolean = false;
  userId: number = -1;
  isNotUserGroup: boolean = true;

  constructor() {}

  hasAccess(): boolean {
    return this.canRead || this.canEdit || this.canDelete;
  }
}
